import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowRight, Phone, Home, Lock } from 'lucide-react';
import { COMPANY_INFO } from '../data';

export default function ForbiddenPage() {
  useEffect(() => {
    document.title = `403 - Ingen adgang | ${COMPANY_INFO.name}`;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', "Du har ikke tilladelse til at tilgå denne ressource (403 Forbidden). Kontakt Vesthimmerlands Maskinskovning ApS ved spørgsmål.");
    }
  }, []);

  return (
    <div className="bg-stone-950 min-h-[75vh] flex flex-col justify-center py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-center space-y-8">
        {/* Status code badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-950/40 border border-red-900/60 text-red-400 text-sm font-bold tracking-widest uppercase">
          <Lock className="w-4 h-4 text-red-400" />
          <span>Fejlkode 403 &bull; Adgang nægtet</span>
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white uppercase tracking-tight">
            Adgang til denne side er begrænset
          </h1>
          <p className="text-stone-400 text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
            Du har ikke tilladelse til at se denne side eller ressource. Hvis du mener dette er en fejl, er du velkommen til at kontakte os.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="pt-6 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#348F57] hover:bg-[#2a7346] text-white font-bold px-7 py-3.5 rounded-xl transition-all shadow-lg shadow-emerald-950/50 hover:shadow-emerald-900/40 uppercase text-sm tracking-wide"
          >
            <Home className="w-4 h-4" />
            <span>Gå til forsiden</span>
          </Link>
          <a
            href={`tel:${COMPANY_INFO.phone.replace(/\s/g, '')}`}
            className="inline-flex items-center gap-2 bg-stone-900 hover:bg-stone-800 text-stone-200 hover:text-white font-bold px-7 py-3.5 rounded-xl transition-all border border-stone-800 uppercase text-sm tracking-wide"
          >
            <Phone className="w-4 h-4 text-emerald-500" />
            <span>Ring <span className="whitespace-nowrap">{COMPANY_INFO.phone}</span></span>
          </a>
        </div>
      </div>
    </div>
  );
}
